import {
    Button,
    Checkbox,
    Form,
    Message,
    Modal,
    Table,
} from 'semantic-ui-react';

import { ORDER_SEARCH_MODAL_NOTICE_MESSAGE } from '../state/gen1ApplicationTrunkingReset';

/**
 * SO# Search 結果モーダル（Select all / Register）
 * @param {{
 *   open: boolean,
 *   orderSearchResult: Object[],
 *   onClose: () => void,
 *   onSelectAllChange: (evn: object, data: object) => void,
 *   onRowToggle: (idx: number) => void,
 *   onRegisterClick: () => void,
 * }} props
 */
export default function OrderSearchModal({
    open = false,
    orderSearchResult = [],
    onClose,
    onSelectAllChange,
    onRowToggle,
    onRegisterClick,
}) {
    if (!open || orderSearchResult.length <= 0) return null;

    return (
        <Modal open onClose={onClose} size="small">
            <Modal.Header>SO# search results</Modal.Header>
            <Modal.Content>
                <Message info>{ORDER_SEARCH_MODAL_NOTICE_MESSAGE}</Message>
                <Form.Field>
                    <Checkbox
                        label="Select all for registration"
                        checked={
                            orderSearchResult.length > 0 &&
                            orderSearchResult.every((r) => r.selected)
                        }
                        indeterminate={
                            orderSearchResult.some((r) => r.selected) &&
                            !orderSearchResult.every((r) => r.selected)
                        }
                        onChange={onSelectAllChange}
                    />
                </Form.Field>
                <Table celled compact size="small">
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell style={{ width: 60 }}>
                                Select
                            </Table.HeaderCell>
                            <Table.HeaderCell>Model</Table.HeaderCell>
                            <Table.HeaderCell>Serial #</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {orderSearchResult.map((row, idx) => (
                            <Table.Row key={row.serialNumber || idx}>
                                <Table.Cell>
                                    <Checkbox
                                        checked={!!row.selected}
                                        onChange={() => onRowToggle(idx)}
                                    />
                                </Table.Cell>
                                <Table.Cell>{row.model}</Table.Cell>
                                <Table.Cell>{row.serialNumber}</Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>
            </Modal.Content>
            <Modal.Actions>
                <Button content="Cancel" onClick={onClose} />
                <Button
                    content="Register selected"
                    color="blue"
                    onClick={onRegisterClick}
                />
            </Modal.Actions>
        </Modal>
    );
}
